import UrqlClient from '@/app/graphql/client';
import { getSdk } from './sdk.notification';

if (!import.meta.env.VITE_APP_ENDPOINT) new Error('Нет переменной VITE_APP_ENDPOINT');

const client = new UrqlClient(`${import.meta.env.VITE_APP_ENDPOINT}/mobile/notification-service/graphql`);
const sdkNotificationService = getSdk(client);

export * from './sdk.notification';
export default sdkNotificationService;
